import { accordion } from "../../base/accordion.js";
import { getData, mhandHttps } from "../../utils.js";
import { addAddressCard } from "./addAddressCard.js";
import { addOrderCard } from "./addOrderCard.js";
import { addTransactionCard } from "./addTransactionCard.js";

export async function getInfo() {
    const section = document.querySelector('.user-section-default');
    if(!section) return;
    getProfileName();
    if (section.dataset.type == 'profile') {
        const res = await getData(`${mhandHttps}api/profile/get-info/`);
        for (const [key, value] of Object.entries(res)) {
            const item = section.querySelector(`[name="${key}"]`);
            if(!!item && !!value) {
                if(item.type === 'text') item.value = value;
                if(item.type === 'radio' && item.dataset.value == value) item.checked;
                if(item.name === 'phone') item.dispatchEvent(new Event("input"));
            }
        };
        const addressSection = document.querySelector('.user-card-default__info-addresses');
        if(addressSection) {
            const resAddress = await getData(`${mhandHttps}api/profile-address/`);
            const fragment = document.createDocumentFragment();
            const promises = resAddress.results.map(async (info)=>{
                const card = await addAddressCard(info);
                fragment.appendChild(card);
            });
            Promise.all(promises).then(()=>addressSection.appendChild(fragment));
        }
    } else if (section.dataset.type == 'order_list') {
        const sectionItems = section.querySelector('.user-card-default__items-block');
        if(sectionItems) {
            const fragment = document.createDocumentFragment();
            const res = await getData(`${mhandHttps}api/profile-order/${window.location.search}`);
            const promises = res.results.map(async(item)=>{
                const card = await addOrderCard(item);
                fragment.appendChild(card);
            });
            Promise.all(promises).then(async()=>{
                await sectionItems.appendChild(fragment);
                accordion(sectionItems);
            });
        }
    } else if (section.dataset.type == 'loyality') {
        const res = await getData(`${mhandHttps}api/profile/get-card-info/`);
        for (const [key, value] of Object.entries(res)) {
            const items = section.querySelectorAll(`[data-attr="${key}"]`);
            items.forEach(item=>{
                if(key === 'qr_code') item.src = value? value : '/static/assets/images/stub.webp';
                if(item.tagName.toLowerCase() === 'span') {
                    const oldInner = item.innerHTML;
                    if(!!Date.parse(value) && typeof value === 'string') {
                        item.innerHTML = new Date(Date.parse(value)).toLocaleDateString('ru-RU');
                    } else {
                        item.innerHTML = value + oldInner;
                    }
                } else if(item.hasAttribute('data-percent')) {
                    item.dataset.percent = value;
                } else if(key === 'is_max_cashback_level' && value) {
                    item.dataset.active = value;
                } else if(key === 'burnable_amount' && !!value) {
                    item.dataset.active = !!value;
                } 
            });
        };
        const transactionsList = document.querySelector('.__transactions_list');
        if(transactionsList) {
            const resTransactions = await getData(`${mhandHttps}api/profile/get-transactions/${window.location.search}`);
            if(resTransactions.length > 0) {
                transactionsList.innerHTML = '';
                const transactionsFragment = document.createDocumentFragment();
                const promises = resTransactions.map(async(item)=>{
                    const card = await addTransactionCard(item);
                    if(!!card) transactionsFragment.appendChild(card);
                });
                Promise.all(promises).then(()=>{
                    transactionsList.appendChild(transactionsFragment)
                });
            };
        };
    };
}
async function getProfileName() {
    const block = document.querySelector('[name="profile_name"]');
    if(!block) return;
    const res = await getData(`${mhandHttps}api/profile/get-info/`);
    if(!!res.first_name) block.innerHTML = `, ${res.first_name}`;
};